import { render } from "./Why.vue?vue&type=template&id=27dc78b0&scoped=true"
import script from "./Why.vue?vue&type=script&lang=js"
export * from "./Why.vue?vue&type=script&lang=js"

import "./Why.vue?vue&type=style&index=0&id=27dc78b0&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27dc78b0"]])

export default __exports__